import APIService from '@/services/APIService';
import Chat from '@/models/list/Chat';

export default {
  getCategories(params) {
    return APIService.get('/mentoring-categories', { params });
  },
  showCategories(id, params) {
    return APIService.get(`/mentoring-categories/${id}`, { params });
  },
  createCategories(payload, params) {
    return APIService.post('/mentoring-categories', payload, { params });
  },
  updateCategories(id, payload, params) {
    return APIService.put(`/mentoring-categories/${id}`, payload, { params });
  },
  deleteCategories(id) {
    return APIService.delete(`/pages/${id}`);
  },
  // categoriesAttachQuestionnaire(id, params) {
  //   return APIService.post(`/mentoring-categories/${id}/questionnaires/attach`, params);
  // },
  // categoriesDetachQuestionnaire(id, params) {
  //   return APIService.post(`/mentoring-categories/${id}/questionnaires/detach`, params);
  // },

  getResources(params) {
    return APIService.get('/pages', { params });
  },
  createResource(params) {
    return APIService.post('/pages', params);
  },
  updateResource(id, params) {
    return APIService.put(`/pages/${id}`, params);
  },
  getResourceConstructor(id, params) {
    return APIService.get(`/pages/${id}`, { params });
  },

  getRecommendations(params) {
    return APIService.get('/course-recommendations', { params });
  },
  createRecommendationPage(payload) {
    return APIService.post('/course-recommendations', payload);
  },
  getProgramForUser(params) {
    return APIService.get('/course-recommendations/for-user', { params });
  },
  getPracticeForUser(params) {
    return APIService.get('/pages/for-user', { params });
  },

  getQuestionnaires(params) {
    return APIService.get('/questionnaires', { params });
  },
  showQuestionnaires(id, params) {
    return APIService.get(`/questionnaires/${id}`, { params });
  },
  createQuestionnaire(params) {
    return APIService.post('/questionnaires', params);
  },
  updateQuestionnaire(id, params) {
    return APIService.put(`/questionnaires/${id}`, params);
  },
  deleteQuestionnaire(id) {
    return APIService.delete(`/questionnaires/${id}`);
  },

  attachQuestionnaireOrganization(orgId, id) {
    return APIService.post(`organizations/${orgId}/questionnaires/${id}/attach`);
  },
  updateQuestionnaireOrganization(orgId, id) {
    return APIService.put(`organizations/${orgId}/questionnaires/${id}`, { is_for_request: true });
  },
  detachQuestionnaireOrganization(orgId, id) {
    return APIService.post(`organizations/${orgId}/questionnaires/${id}/detach`);
  },
  attachQuestionnaireUser(id, payload) {
    return APIService.post(`questionnaires/users/${id}/attach`, payload);
  },
  detachQuestionnaireUser(id, payload) {
    return APIService.post(`questionnaires/users/${id}/detach`, payload);
  },

  getQuestions(params) {
    return APIService.get('/questions', { params });
  },
  showQuestions(id, params) {
    return APIService.get(`/questions/${id}`, { params });
  },
  createQuestions(params) {
    return APIService.post('/questions', params);
  },
  updateQuestions(id, params) {
    return APIService.put(`/questions/${id}`, params);
  },
  deleteQuestions(id) {
    return APIService.delete(`/questions/${id}`);
  },

  getQuestionsVariants(params) {
    return APIService.get('/question-variants', { params });
  },
  showQuestionsVariants(id, params) {
    return APIService.get(`/question-variants/${id}`, { params });
  },
  createQuestionsVariants(params) {
    return APIService.post('/question-variants', params);
  },
  updateQuestionsVariants(id, params) {
    return APIService.put(`/question-variants/${id}`, params);
  },
  deleteQuestionsVariants(id) {
    return APIService.delete(`/question-variants/${id}`);
  },

  getQuestionnaireForms(params) {
    return APIService.get('/questionnaire-forms', { params });
  },
  showQuestionnaireForms(id, params) {
    return APIService.get(`/questionnaire-forms/${id}`, { params });
  },
  createQuestionnaireForms(params) {
    return APIService.post('/questionnaire-forms', params);
  },
  updateQuestionnaireForms(id, params) {
    return APIService.put(`/questionnaire-forms/${id}`, params);
  },
  deleteQuestionnaireForms(id) {
    return APIService.delete(`/questionnaire-forms/${id}`);
  },

  getFormAnswer(params) {
    return APIService.get('/form-answers', { params });
  },
  showFormAnswer(id, params) {
    return APIService.get(`/form-answers/${id}`, { params });
  },
  createFormAnswer(params) {
    return APIService.post('/form-answers', params);
  },
  updateFormAnswer(id, params) {
    return APIService.put(`/form-answers/${id}`, params);
  },
  deleteFormAnswer(id) {
    return APIService.delete(`/form-answers/${id}`);
  },

  getMyRequests(params) {
    return APIService.get('organizations/mentoring/my-requests', { params });
  },
  sendRequest(id, params) {
    return APIService.post(`organizations/${id}/mentoring/send-request`, params);
  },

  requestList(id, params) {
    return APIService.get(`organizations/${id}/mentoring`, { params });
  },
  acceptRequest(orgId, userId, params) {
    return APIService.post(`organizations/${orgId}/mentoring/users/${userId}/accept-request`, params);
  },
  setMentor(orgId, userId, payload, params) {
    return APIService.post(`organizations/${orgId}/mentoring/users/${userId}/set-mentor`, payload, params);
  },

  setMentorRole(orgId, userId) {
    return APIService.put(`organizations/${orgId}/users/${userId}`, { role: 8 });
  },

  attachRegion(payload) {
    return APIService.post('organizations/region-distribution/attach', payload);
  },
  detachRegion(payload) {
    return APIService.post('organizations/region-distribution/detach', payload);
  },

  openChat(orgId, userId, params) {
    return APIService.get(
      `/organizations/${orgId}/mentoring/users/${userId}/chat-room`,
      {
        params,
        rOptions: {
          model: Chat,
        },
      },
    );
  },

  programAttachTags(id, payload) {
    return APIService.post(`tags/course-recommendations/${id}/tags/attach`, payload);
  },
  programDetachTags(id, payload) {
    return APIService.post(`tags/course-recommendations/${id}/tags/detach`, payload);
  },
  practiceAttachTags(id, payload) {
    return APIService.post(`tags/pages/${id}/tags/attach`, payload);
  },
  practiceDetachTags(id, payload) {
    return APIService.post(`tags/pages/${id}/tags/detach`, payload);
  },

  mentorRecommendations(params) {
    return APIService.get('/mentor-recommendations', { params });
  },
  mentorRecommendation(id, params) {
    return APIService.get(`/mentor-recommendations/${id}`, { params });
  },
  createRecommendation(params) {
    return APIService.post('/mentor-recommendations', params);
  },
  updateRecommendation(id, params) {
    return APIService.put(`/mentor-recommendations/${id}`, params);
  },
  deleteRecommendation(id, params) {
    return APIService.delete(`/mentor-recommendations/${id}`, params);
  },

  attachRecommendation(id, params) {
    return APIService.post(`/mentor-recommendations/${id}/users/attach`, params);
  },
  detachRecommendation(id, params) {
    return APIService.post(`/mentor-recommendations/${id}users/detach`, params);
  },
};
